import { useState } from 'react'

export function usePasswordInputHook() {
  const [passwordInput, setPasswordInput] = useState('')
  return [passwordInput, setPasswordInput]
}
